<template>
  <div class="wizard-panel">
    <div class="wizard-card">
      <div class="wizard-card-content">
        <h2>BRAND NAME</h2>
        <p>The best brand names are short, memorable and easy to Google</p>
        <p>
          <span>Still need a name?&emsp;&emsp;</span>
          <a class="btn" href="https://namelix.com" target="_blank" title="Business Name Generator">Generate one&emsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="11.03" height="11.029" viewBox="0 0 11.03 11.029">
              <path d="M4842.243,598.461a1.181,1.181,0,0,1-.839-2.019l5.632-5.632-2.337-2.34a.637.637,0,0,1-.177-.431.607.607,0,0,1,.607-.607h6.063a.9.9,0,0,1,.9.9v6.063a.6.6,0,0,1-1.028.434l-2.345-2.341-5.634,5.634A1.175,1.175,0,0,1,4842.243,598.461Z" transform="translate(-4841.057 -587.432)" fill="#fff"/>
            </svg>
          </a>
        </p>
      </div>
    </div>
    <div class="wizard-card">
      <div class="wizard-card-content">
        <div>
          <input type="text" placeholder="Brand name" v-model="brandName" class="input"/>
          <input type="text" placeholder="Slogan (optional)" v-model="slogan" class="input"/>
        </div>
        <div class="wizard-card-actions">
          <button @click="nextStep" class="btn btn-big next-step-big-btn" :disabled="!isCurrStepValid">
            Next&emsp;&emsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="9.191" height="14.718" viewBox="0 0 9.191 14.718">
              <path d="M2156.239,749.889l2.373-2.373c2.924-2.925,3.166-3.192,3.166-3.192s-.242-.228-3.181-3.167l-2.388-2.388.367-.366c.147-.148.275-.275.381-.379.551.545,1.687,1.676,3.172,3.161l3.149,3.149-3.139,3.139c-1.481,1.481-2.613,2.608-3.163,3.152C2156.869,750.519,2156.239,749.889,2156.239,749.889Z" transform="translate(-2155.148 -736.966)" fill="#fff" stroke="#fff" stroke-miterlimit="10" stroke-width="1.5"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  name: 'BrandName',
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters('wizard', [
      'currStep',
      'isCurrStepValid',
    ]),
    brandName: {
      get () {
        return this.$store.state.wizard.brandName
      },
      set (value) {
        return this.$store.commit('wizard/SET_BRAND_NAME', value)
      }
    },
    slogan: {
      get () {
        return this.$store.state.wizard.slogan
      },
      set (value) {
        return this.$store.commit('wizard/SET_SLOGAN', value)
      }
    },
  },
  methods: {
    ...mapActions('wizard', [
      'nextStep',
    ])
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.wizard-panel {
  z-index: 4;
}

.wizard-card:nth-child(1) {
  background-color: $cloudy-blue;
}

.next-step-big-btn {
  background-color: $pale-teal;

  &:disabled {
    background-color: $very-light-pink;
  }
}
</style>
